function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "url(#dashboard-todos_svg__paint0_linear)"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40 20.839L29.548 10.387 9.678 30.323 19.354 40H20c10.774 0 19.548-8.516 20-19.161z",
  fill: "#000"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.677 30.323s4.323-.968 5.549-1.936l-3.613-3.613c-.968 1.226-1.936 5.549-1.936 5.549zm14.84-18.452l-12 12 3.677 3.677 12-12-3.678-3.677z",
  fill: "#FFFCF2"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.613 24.774l3.677 3.678.904-.904-3.678-3.677-.903.903zm13.806-13.806l-.903.903 3.678 3.677.903-.903-3.678-3.677z",
  fill: "#344E5F"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.742 9.677c-.71 0-1.355.258-1.807.775l-.516.516 3.678 3.677.516-.516c.451-.452.774-1.097.774-1.806-.064-1.484-1.226-2.646-2.645-2.646z",
  fill: "#EDC03D"
});
var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "dashboard-todos_svg__paint0_linear",
  x1: 0,
  y1: 0,
  x2: 39.142,
  y2: -0.822,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0E72ED"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6597FF"
})));
function SvgDashboardTodos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}
export default __webpack_public_path__ + "fonts/dashboard-todos-1f018b990b70aae18036a773c5002b9b.svg";
export { SvgDashboardTodos as ReactComponent };